import _taggedTemplateLiteral from "/vercel/workpath0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";
import _classCallCheck from "/vercel/workpath0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/workpath0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/vercel/workpath0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/vercel/workpath0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n        :host {\n          display: block;\n          position: relative;\n        }\n      "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["<svg></svg>"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

import { customElement, property, css, html } from 'lit-element';
import { WiredBase, BaseCSS } from 'wired-lib/lib/wired-base';
import { line } from 'wired-lib';

var WiredDivider = /*#__PURE__*/function (_WiredBase) {
  _inherits(WiredDivider, _WiredBase);

  var _super = _createSuper(WiredDivider);

  function WiredDivider() {
    var _this;

    _classCallCheck(this, WiredDivider);

    _this = _super.apply(this, arguments);
    _this.elevation = 1;
    return _this;
  }

  _createClass(WiredDivider, [{
    key: "render",
    value: function render() {
      return html(_templateObject());
    }
  }, {
    key: "canvasSize",
    value: function canvasSize() {
      var size = this.getBoundingClientRect();
      var elev = Math.min(Math.max(1, this.elevation), 5);
      return [size.width, elev * 6];
    }
  }, {
    key: "draw",
    value: function draw(svg, size) {
      var elev = Math.min(Math.max(1, this.elevation), 5);

      for (var i = 0; i < elev; i++) {
        line(svg, 0, i * 6 + 3, size[0], i * 6 + 3, this.seed);
      }
    }
  }], [{
    key: "styles",
    get: function get() {
      return [BaseCSS, css(_templateObject2())];
    }
  }]);

  return WiredDivider;
}(WiredBase);

__decorate([property({
  type: Number
}), __metadata("design:type", Object)], WiredDivider.prototype, "elevation", void 0);

WiredDivider = __decorate([customElement('wired-divider')], WiredDivider);
export { WiredDivider };